import { CircularProgress, CircularProgressProps, createStyles, makeStyles, Theme } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: "flex",
			justifyContent: "center",
			"& > * + *": {
				marginLeft: theme.spacing(2),
			},
		},
		bottom: {
			color: "#367bf563",
			position: "absolute",
		},
	})
);

export default function CircularIndeterminate({ circularTrack, ...props }: CircularProgressProps & { circularTrack?: boolean }) {
	const classes = useStyles();

	if (circularTrack) {
		return (
			<div>
				<CircularProgress variant="determinate" value={100} className={classes.bottom} {...props} />
				<CircularProgress {...props} />
			</div>
		);
	}

	return (
		<div className={classes.root}>
			<CircularProgress {...props} />
		</div>
	);
}
